import AssetsPage from '../pages/main/assets/assets-page'
export default AssetsPage
